<template>
	<div
		v-if="user.member_id"
		class="full-height"
	>
		<div>
			<div class="mt-10 justify-space-between">
				<h6>현장 목록</h6>

				<button
					v-if="user.member_level >= 3"
					class="btn btn-primary"

					@click="toProject"
				>현장 등록</button>
			</div>

			<div class="mt-10">
				<ul
					v-if="item_list.length > 0"
				>
					<template
						v-for="project in item_list"
					>
						<li
							:key="project.uid"

							class="box radius-10 pa-20 cursor-pointer mb-10"

							@click="toDetail(project.uid)"
						>
							<div
								class="size-px-16 font-weight-bold"
							>{{ project.project_name}}</div>
							<div
								class="mt-10 text-right"
							>{{ project.sDate }} ~ {{ project.eDate }}</div>
						</li>
					</template>

					<Pagination
						:program="program"
						:align="'center'"
						:options="item_search"

						@click="getData"

						class="mt-auto pa-10"
					></Pagination>
				</ul>

				<Empty
					v-else
					class="mt-10"
				></Empty>
			</div>
		</div>
	</div>
</template>

<script>
import Empty from "../Layout/Empty";
import Pagination from "../../components/Pagination";
export default{
	name: 'Main'
	, components: {Pagination, Empty}
	, props: ['user']
	,data: function(){
		return {
			program: {
				name: process.env.VUE_APP_TITLE_DEV
				,title: false
				,search: true
				,bottom: true
				, is_container: true
			}
			, items: []
			, item_search: {
				page: 1
				, list_cnt: 10
			}
		}
	}
	,computed: {
		item_list: function (){

			return this.items.filter((item) => {
				return item
			})
		}
	}
	,methods: {
		getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectList'
					, data: this.item_search
				})

				if (result.success) {

					this.items = result.data.result
					this.$set(this.item_search, 'total_count', result.data.tCnt)
					this.$storage.setQuery(this.item_search)

				} else {
					this.$bus.$emit('notify', {type: 'error', message: result.message})
				}
			}catch (e) {
				console.log(e)
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, toNotice: function(){
			this.$bus.$emit('to', { name: 'CustomerCenter', params: {b_code: 'b_notice'}})
		}
		, getSearch: function(type){
			this.item_search.type = type
			this.getData()
		}
		, toQna: function(){
			this.$bus.$emit('to', { name: 'BbsItem', params: { b_code: 'b_qna' }})
		}
		, toProject: function(){
			this.$bus.$emit('to', { name: 'ProjectItem'})
		}
		, toDetail: function(idx){
			this.$bus.$emit('to', {name: 'ProjectView', params: { idx: idx}})
		}
	}
	,created: async function(){
		this.$bus.$emit('onLoad', this.program)

		await this.getData()
	}
}

</script>

<style>

</style>